
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/applications",
      function () {
        return require("private-next-pages/applications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/applications"])
      });
    }
  